import React, { useState, useRef } from 'react'
import './Createnewdatalibrary.css'
import DataLibraryManagement from "../../../Services/DataLibraryService/DataLibraryService"
import showToast from '../../../Utils/Toast/ToastNotification';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { Modal } from 'bootstrap';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { useSelector } from 'react-redux';

const Createnewdatalibrary = () => {

    const maxColumns = 10

    const navigate = useNavigate()
    const dispatch = useDispatch();

    const created_by = useSelector(
        (state) => state.auth.user.data?.body?.data?.userData?.id
    );

    const token = useSelector(
        (state) => state.auth.user.data?.body?.data?.token
    );

    const [nameError, setNameError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [columns, setColumns] = useState(['']);
    const [rows, setRows] = useState([['']]);

    const handleAddColumn = () => {
        setColumns([...columns, '']);
        setRows(rows.map(row => [...row, '']));
    };

    const handleRemoveColumn = (colIndexToRemove) => {
        setColumns(prev => prev.filter((_, i) => i !== colIndexToRemove));
        setRows(prevRows =>
            prevRows.map(row => row.filter((_, i) => i !== colIndexToRemove))
        );
    };

    const handleHeaderChange = (index, value) => {
        const newCols = [...columns];
        newCols[index] = value;
        setColumns(newCols);
    };

    const handleCellChange = (rowIndex, colIndex, value) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex][colIndex] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        const newRow = new Array(columns.length).fill('');
        setRows([...rows, newRow]);
    };

    const handleRemoveRow = (rowIndex) => {
        const updatedRows = rows.filter((_, idx) => idx !== rowIndex);
        setRows(updatedRows);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let isValid = true;

        if (!name.trim()) {
            setNameError('Name is required');
            isValid = false;
        } else {
            setNameError('');
        }

        if (!description.trim()) {
            setDescriptionError('Description is required');
            isValid = false;
        } else {
            setDescriptionError('');
        }

        const hasEmptyHeader = columns.some(header => !header || header.trim() === '');
        if (hasEmptyHeader) {
            showToast('error', 'Please fill in all column headers before submitting.');
            isValid = false;
        }

        // for the data library headers 
        for (let rawHeader of columns) {
            const header = typeof rawHeader === 'string' ? rawHeader : String(rawHeader);
            if (/^\s/.test(header)) {
                showToast('error', `Leading spaces are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }

            if (/\s$/.test(header)) {
                showToast('error', `Trailing spaces are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }

            if (/\w\s+\w/.test(header)) {
                showToast('error', `Spaces between words are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }
        }

        if (!isValid) return;

        const payload = {
            name,
            description,
            created_by: created_by, // Replace with dynamic value
            headers: columns,
            rows: rows.map(row => {
                const [category, ...rest] = row;
                const values = {};
                columns.slice(1).forEach((col, i) => {
                    values[col] = rest[i];
                });
                return { Category: category, values };
            }),
        };

        try {
            const saveDetails = await DataLibraryManagement.addDataLibrary(payload, token);
            if (saveDetails?.data?.statusCode === 200) {
                showToast("success", saveDetails?.data?.body?.message);
                const dataLibraryId = saveDetails?.data?.body?.data?.dataLibrary?.id;
                if (dataLibraryId) {
                    navigate(`/update-datalibrary/${dataLibraryId}`);
                }
                // setName("");
                // setDescription("");
                // setColumns([]); // Default to just Category column
                // setRows([]); // Clear all rows
                setNameError("");
                setDescriptionError("");

            } else {
                showToast("error", saveDetails?.data?.message);
            }
        } catch (error) {
            await HandleApiError(error);
        }
    };

    const handleBack = () => {
        navigate(-1); // Goes back one page in history
    };


    const closeButtonRef = useRef(null)

    const handleFileImport = (e) => {
        dispatch(showLoader());
        const file = e.target.files[0];
        if (!file) return;

        const fileName = file.name.toLowerCase();
        const isCSV = fileName.endsWith(".csv");

        const reader = new FileReader();

        reader.onload = (evt) => {
            let workbook;

            if (isCSV) {
                const csvData = evt.target.result;
                workbook = XLSX.read(csvData, { type: "binary" });
            } else {
                const data = new Uint8Array(evt.target.result);
                workbook = XLSX.read(data, { type: "array" });
            }

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const [headersRaw, ...rowsRaw] = jsonData;
            const headers = headersRaw.map(h => h.toString().trim());

            const rows = rowsRaw.map(row => {
                const rowObj = {};
                headers.forEach((header, index) => {
                    rowObj[header] = row[index] || "";
                });

                return {
                    [headers[0]]: rowObj[headers[0]],
                    values: Object.fromEntries(
                        Object.entries(rowObj).filter(([key]) => key !== headers[0])
                    )
                };
            });

            if (headers.length > 0 && rows.length > 0) {
                setColumns(headers);

                const parsedRows = rows.map(row => {
                    const rowArray = [row[headers[0]]];
                    headers.slice(1).forEach(header => {
                        rowArray.push(row.values[header] || '');
                    });
                    return rowArray;
                });

                setRows(parsedRows);

                if (closeButtonRef.current) {
                    closeButtonRef.current.click();
                    dispatch(hideLoader());
                }
            }
        };

        if (isCSV) {
            reader.readAsBinaryString(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    };




    return (

        <>
            <div className='main-inner-block'>
                <div className='content'>
                    <div className='d-flex align-items-center justify-content-between mb-4 block-one'>
                        <div className='heading-content mt-0'>
                            Create Data Library
                        </div>

                    </div>

                    <div className='white-box'>

                        <form onSubmit={handleSubmit}>
                            <div className="create-library-block">
                                <div className="add-project-area d-flex flex-wrap align-items-center justify-content-between">
                                    <div className='d-flex align-items-center flex wrap gap-4'>
                                        <div className="data-library-box">
                                            <label htmlFor="name" className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="Enter Name"
                                                value={name}
                                                onChange={(e) => {
                                                    setName(e.target.value);
                                                    if (e.target.value.trim()) {
                                                        setNameError('');
                                                    }
                                                }}
                                            />
                                            {nameError && <small className="text-danger">{nameError}</small>}
                                        </div>
                                        <div className="add-project-box update-details update-lib-textbox">
                                            <label htmlFor="description" className="form-label">Descriptions</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                                style={{ height: '38px' }}
                                                placeholder="Enter Description"
                                                value={description}
                                                onChange={(e) => {
                                                    setDescription(e.target.value);
                                                    if (e.target.value.trim()) {
                                                        setDescriptionError('');
                                                    }
                                                }}
                                            />
                                            {descriptionError && <small className="text-danger">{descriptionError}</small>}
                                        </div>
                                    </div>


                                    <div className='import-excel'>
                                        <button
                                            className="green-btn green-signin addnewuser excel-icon"
                                            type='button'
                                            data-bs-toggle="modal"
                                            data-bs-target="#importModal"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="none" viewBox="0 0 24 24">
                                                <path fill="#217346" d="M4 2h10l6 6v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                                                <path fill="#fff" d="M14 3.5V8h4.5L14 3.5z" />
                                                <path fill="#fff" d="M8 10h1.2l1.1 2.1L11.5 10H13l-1.7 3 1.8 3h-1.5l-1.2-2.2-1.2 2.2H7.8l1.8-3L8 10z" />
                                            </svg>

                                            Import
                                        </button>

                                        <div className="modal fade" id="importModal" tabIndex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content p-3">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="importModalLabel">Import Excel</h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButtonRef}></button>
                                                    </div>

                                                    <div className="modal-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="excelFile" className="form-label">Choose Excel file</label>
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                id="excelFile"
                                                                accept=".xlsx,.xls,.csv"
                                                                onChange={handleFileImport}
                                                            />
                                                        </div>
                                                        <p>
                                                            Sample Excel:{" "}
                                                            <a href="/data_library.xlsx" download="data_library.xlsx" style={{ textDecoration: "underline", color: "#217346" }}>
                                                                data_library.xlsx
                                                            </a>
                                                        </p>
                                                    </div>

                                                    <div className="modal-footer">
                                                        <button
                                                            type="button"
                                                            className="green-btn green-signin addnewuser"
                                                            data-bs-dismiss="modal"
                                                        >
                                                            Cancel
                                                        </button>
                                                        {/* <button
                                                        type="button"
                                                        className="green-btn"
                                                        onClick={handleExcelImport}
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Import
                                                    </button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                </div>

                                <div className='category-table sm-box mt-4 table-responsive w-100'>
                                    <table className="table align-middle mb-0">
                                        <thead className="table-bg">
                                            <tr>
                                                {columns.map((col, i) => (
                                                    <th key={i} className="position-relative">
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                type="text"
                                                                value={col}
                                                                onChange={(e) => handleHeaderChange(i, e.target.value)}
                                                                className="form-control form-control-sm me-1"
                                                            />
                                                            {i > 0 && (
                                                                <div className="delete-icon cursor-pointer" onClick={() => handleRemoveColumn(i)}>
                                                                    {/* Delete Icon */}
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M2 4H3.33333H14" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M6.66602 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M9.33398 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </th>
                                                ))}
                                                <th>
                                                    {columns.length < maxColumns && (
                                                        <a className='add-category-box' href="#" onClick={(e) => { e.preventDefault(); handleAddColumn(); }}>
                                                            {/* Add Column Icon */}
                                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <path d="M8.40039 3.33398V12.6673" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M3.73438 8H13.0677" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </a>
                                                    )}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((cell, colIndex) => (
                                                        <td key={colIndex}>
                                                            <input
                                                                type="text"
                                                                value={cell}
                                                                onChange={(e) => handleCellChange(rowIndex, colIndex, e.target.value)}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </td>
                                                    ))}
                                                    <td>
                                                        <div className='delete-icon cursor-pointer' onClick={() => handleRemoveRow(rowIndex)}>
                                                            {/* Delete Icon */}
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M2 4H3.33333H14" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M6.66602 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M9.33398 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={columns.length + 1}>
                                                    <div className='add-row cursor-pointer' onClick={handleAddRow}>
                                                        <span className='me-2'>
                                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <path d="M8.40039 3.33398V12.6673" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M3.73438 8H13.0677" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </span>
                                                        Add Row
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="text-center update-div d-flex align-items-center justify-content-center gap-2">
                                    <button
                                        type="button"
                                        className="green-btn submit-btn"
                                        onClick={() => navigate("/datalibrary-listing")}
                                    >
                                        Back
                                    </button>
                                    <button
                                        type="submit"
                                        className="green-btn submit-btn"
                                    // style={{ marginLeft: "10px" }}
                                    >
                                        Save
                                    </button>
                                </div>
                                {/* <button type="submit" className="green-btn green-signin addnewuser mt-3">Submit</button> */}
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </>
    )
}

export default Createnewdatalibrary